<template>
    <div class="lw-notif-popup lw-body-bg" v-show="notificationDisplay">
        <div class="close dark-gray-close" @click="popupDisplay = false"></div>
        <!--<h3 class="lw-notif-popup-title learnworlds-heading3 learnworlds-heading3-normal learnworlds-element"></h3>-->
        <p class="learnworlds-main-text lw-text-color-fadeout20 learnworlds-element learnworlds-main-text-normal">You are in Preview Mode</p>
        <button class="learnworlds-button learnworlds-button-small learnworlds-button-solid-brand" @click="exitPreview">Exit Preview Mode</button>
    </div>
</template>

<script>

    import { mapState } from 'vuex';

    export default {
        name: "PreviewModeNotification",
        data(){
            return {
                popupDisplay: true
            }
        },
        computed: {
            ...mapState('pages',[
                'previewSiteTemplateId'
            ]),
            notificationDisplay () {
                return this.previewSiteTemplateId && this.popupDisplay;
            }
        },
        methods: {
            exitPreview(){
                const glue = window.location.search ? '&' : '?';
                window.top.location.href = window.location.href + glue + 'preview_exit=true';
            }
        }
    }
</script>

